import { useQuery } from "@tanstack/react-query";
import { formatMoney } from "@melhot/shared/money";
import { adminApi } from "../api";
import { Panel } from "../components/DataTable";

export function DashboardPage() {
  const overview = useQuery({ queryKey: ["admin-overview"], queryFn: adminApi.overview, refetchInterval: 5000 });
  const data = overview.data;

  const cards = [
    { label: "Sessões Totais", value: data?.sessions ?? 0, color: "#0f172a" },
    { label: "Checkouts Abertos", value: data?.openSessions ?? 0, color: "#475569" },
    { label: "Aguardando PIX", value: data?.waitingPayment ?? 0, color: "#d97706" },
    { label: "PIX Pagos", value: data?.paidPayments ?? 0, color: "#059669" },
    { label: "Taxa de Pago no PIX", value: `${data?.pixConversionRate ?? 0}%`, color: "#2563eb", highlight: true },
    { label: "Receita Paga", value: formatMoney(data?.revenuePaid ?? 0), color: "#059669" },
    { label: "Pedidos Criados", value: data?.orders ?? 0, color: "#0f172a" },
    { label: "Sync Shopify Pendente", value: data?.shopifyPending ?? 0, color: "#dc2626" }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-ink">Dashboard de Vendas & Pagamentos</h1>
          <p className="text-sm text-slate-500">Métricas em tempo real de checkouts, aprovação de PIX e sincronização</p>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-4">
        {cards.map((card) => (
          <div
            key={card.label}
            className={`rounded-lg border bg-white p-5 shadow-sm ${
              card.highlight ? "border-blue-500 ring-2 ring-blue-100" : "border-line"
            }`}
          >
            <span className="text-xs font-bold uppercase tracking-wider text-slate-500">{card.label}</span>
            <p className="mt-2 text-2xl font-extrabold" style={{ color: card.color }}>
              {card.value}
            </p>
          </div>
        ))}
      </div>

      {/* PIX APPROVAL PERFORMANCE PANEL */}
      <div className="rounded-lg border border-line bg-white p-6 shadow-sm">
        <h2 className="text-lg font-bold text-ink mb-4">⚡ Desempenho & Aprovação de Pagamentos PIX</h2>
        <div className="grid gap-6 md:grid-cols-3">
          <div className="rounded-md border border-slate-100 bg-slate-50 p-4">
            <span className="text-xs font-semibold text-slate-500 uppercase">PIX Gerados vs Pagos</span>
            <div className="mt-2 flex items-baseline gap-2">
              <span className="text-2xl font-bold text-ink">{data?.paidPayments ?? 0}</span>
              <span className="text-sm text-slate-500">de {data?.pixTotalGenerated ?? 0} gerados</span>
            </div>
            <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-slate-200">
              <div
                className="h-full bg-emerald-500 transition-all duration-500"
                style={{ width: `${Math.min(100, Math.max(0, data?.pixConversionRate ?? 0))}%` }}
              />
            </div>
          </div>

          <div className="rounded-md border border-slate-100 bg-slate-50 p-4">
            <span className="text-xs font-semibold text-slate-500 uppercase">Receita Confirmada (Paga)</span>
            <p className="mt-2 text-2xl font-bold text-emerald-600">{formatMoney(data?.revenuePaid ?? 0)}</p>
            <p className="mt-1 text-xs text-slate-500">Valores com confirmação imediata via webhook Umbrellapag</p>
          </div>

          <div className="rounded-md border border-slate-100 bg-slate-50 p-4">
            <span className="text-xs font-semibold text-slate-500 uppercase">Receita Pendente em Aberto</span>
            <p className="mt-2 text-2xl font-bold text-amber-600">{formatMoney(data?.revenuePending ?? 0)}</p>
            <p className="mt-1 text-xs text-slate-500">Aguardando pagamento antes da expiração do QR Code</p>
          </div>
        </div>
      </div>
    </div>
  );
}
